import { YStack } from 'smoothie';

import { GHOST_BG } from './goalsWaterfallConstants';

interface PlaceholderSectionProps {
    height: number;
    borderRadius?: number;
}

export const PlaceholderSection = ({
    height,
    borderRadius = 16,
}: PlaceholderSectionProps) => (
    <YStack
        height={height}
        backgroundColor={GHOST_BG}
        borderRadius={borderRadius}
    />
);
